import React from 'react'
import Image from 'next/image'
import { Box, Button } from '@mui/material'
import { ShoesModel } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { borderStyle } from 'src/style/muiTheme'

type Props = {
  model: ShoesModel
  selectedModel: ShoesModel
  isOnlyImage?: boolean
  setSelectedModel: React.Dispatch<React.SetStateAction<ShoesModel>>
}

export const ShoesModelCard: React.FC<Props> = ({ model, selectedModel, isOnlyImage = false, setSelectedModel }) => {
  const { t } = useLocale()
  const isSelected = selectedModel?.productNumber === model.productNumber
  return (
    <Box p={1}>
      <Button
        data-testid={'model-card-button'}
        variant={isSelected ? 'contained' : 'outlined'}
        color={isSelected ? 'primary' : 'inherit'}
        style={{ maxWidth: '250px', border: borderStyle }}
        onClick={() => setSelectedModel(model)}
      >
        <Box component={'span'} style={{ maxWidth: '300px', display: 'inline-block' }}>
          <Image src={model.image.url} alt={model.productNumber} width={model.image.width} height={model.image.height} />
          {!isOnlyImage && (
            <>
              <Box component={'h4'}>
                <Box>
                  {t.PRODUCT_NUMBER}
                  {model.productNumber}
                </Box>
              </Box>
              {model.size > 0 && <Box textTransform={'none'}>{`${model.size} ${t.SIZE_UNIT}`}</Box>}
              <Box textTransform={'none'}>{model.description}</Box>
            </>
          )}
        </Box>
      </Button>
    </Box>
  )
}
